import { Button } from '@/components/ui/button';
import { FiCalendar } from 'react-icons/fi';
import { FiClock } from 'react-icons/fi';
import { FaRegClock } from 'react-icons/fa';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

type LandingPageFooterProps = {
  consultationDate?: Date;
  consultationDuration?: number;
  buttonLabel: string;
  onClick: () => void;
  disabled?: boolean;
};

export const LandingPageFooter = ({
  consultationDate,
  consultationDuration,
  buttonLabel,
  onClick,
  disabled = false,
}: LandingPageFooterProps) => {
  const hasHeader = consultationDate || consultationDuration;

  return (
    <div className="flex flex-col items-center mx-1 mb-2 w-fit w-full min-w-0">
      <div
        className={`flex flex-col items-center rounded-xl px-4 pb-4 ${
          hasHeader ? 'border border-gray-300' : ''
        }`}
      >
        {consultationDate && (
          <div className="w-full flex items-center justify-center gap-1 my-4">
            <div className="flex items-center gap-2">
              <FiCalendar className="w-6 h-6" />
              <span className="capitalize">
                {format(consultationDate, 'EEEE d MMMM', { locale: fr })}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <FiClock className="w-6 h-6 ml-2" />
              <span>{format(consultationDate, "HH'h'mm", { locale: fr })}</span>
            </div>
          </div>
        )}
        {consultationDuration && !consultationDate && (
          <div className="flex items-center gap-2 my-3">
            <FaRegClock className="w-5 h-5" />
            <p className="text-sm font-light">
              Durée estimée : {consultationDuration} min
            </p>
          </div>
        )}
        <Button
          variant="ctaPrimary"
          size="lg"
          onClick={onClick}
          disabled={disabled}
        >
          {buttonLabel}
        </Button>
      </div>
      <p
        className={`text-xs text-gray-500 text-center ${
          hasHeader ? 'mt-4' : ''
        }`}
      >
        En continuant, vous acceptez les{' '}
        <a
          className="underline cursor-pointer"
          target="_blank"
          rel="noreferrer"
          href="https://aldebaran.care/legal/cgu-patient"
        >
          conditions générales <br /> d&apos;utilisation
        </a>{' '}
        et la{' '}
        <a
          className="underline cursor-pointer"
          href="https://aldebaran.care/legal/politique-protection-donnees"
          target="_blank"
          rel="noopener noreferrer"
        >
          politique de protection des données
        </a>
        .
      </p>
    </div>
  );
};
